export const API_BASE_URL = process.env.REACT_APP_BACK_END_SERVER_API;

export const COMMUNITIES_URL = `${API_BASE_URL}/communities`;

export const PROPOSALS_URL = `${API_BASE_URL}/proposals`;

export const IPFS_GETWAY = `${process.env.REACT_APP_IPFS_GATEWAY}`;
